import './TeamCard.scss'

import Button from '../../../components/Button/Button'
import Checkbox from '../../Checkbox/Checkbox'
import Icon from '../../../components/Icon/Icon'
import PropTypes from 'prop-types'
import React from 'react'
import t from '../../../helpers/i18n'

const TeamCard = ({
  name,
  tags,
  logo,
  players,
  staff,
  delegates,
  categoryName,
  categoryLogo,
  organizationName,
  onClick,
}) => {
  return (
    <div className='team-card-module'>
      <div className='-header'>
        <div className='-controls'>
          <div className='-menu'>
            <Checkbox />
            <div className="-divider" />
            <Icon size={16} icon='MoreIcon' />
          </div>
          <div className='-team-name proper-noun-large-semibold'>
            {name}
          </div>
          {tags && tags.map((tag, index) => (
            <div key={index} className='-tags overline-label-small-basic'>
              <span>{tag}</span>
            </div>
          ))}
        </div>
        <div className='-logo'>
          {logo && <img src={logo} alt='' />}
        </div>
      </div>

      <div className='-description'>
        <div className='-row'>
          <div className='-label label-small-basic'>{t('labels.Category')}</div>
          <div className='-data proper-noun-small-medium'>{categoryName}</div>
          <div className='-logo'><img src={categoryLogo} alt='' /></div>
        </div>

        {organizationName &&
          <div className='-row'>
            <div className='-label label-small-basic'>{t('labels.Organization')}</div>
            <div className='-data proper-noun-small-medium'>{organizationName}</div>
          </div>
        }

        <div className='-buttons'>
          <div className="-button label-small-basic"><Icon icon="PlayersIcon" size="24" />{players}</div>
          <div className="-button label-small-basic"><Icon icon="DelegatesIcon" size="24" />{delegates}</div>
          <div className="-button label-small-basic"><Icon icon="TechnicalStaffIcon" size="24" />{staff}</div>
        </div>
      </div>

      <div className='-main-button'>
        <Button
          size='field-sized'
          type='light'
          color='green'
          label='Ver equipo'
          icon='ArrowRightIcon'
          iconPosition='trailing'
          grow
          onClick={onClick}
        />
      </div>
    </div>
  )
}

TeamCard.propTypes = {
  name: PropTypes.string,
  tags: PropTypes.array,
  logo: PropTypes.string,
  players: PropTypes.number,
  staff: PropTypes.number,
  delegates: PropTypes.number,
  categoryName: PropTypes.string,
  categoryLogo: PropTypes.string,
  onClick: PropTypes.func,
}

TeamCard.defaultProps = {}

export default TeamCard
